import $ from 'jquery';

export const imageModal = () => {
    const images = $('.blog-post .blog-post__img');
    const modal = $('.blog-post .modal');
    const modalCloseBtn = $('.modal .modal__close');

    if (images.length && $(window).width() > 767) {
        $(images).on('click', function() {
            let imageSrc = $(this).data('modal-image');
            let imageAlt = $(this).find('img').attr('alt');
            let imageDesc = $(this).data('modal-text');

            if ((imageDesc?.length ?? 0) <= 1) {
                imageDesc = $(this).find('span').text();
            }

            $(modal).find('.modal__img').attr('src', imageSrc);
            $(modal).find('.modal__img').attr('alt', imageAlt);
            $(modal).find('.modal__desc').text(imageDesc);

            $(modal).addClass('modal--active');
        });

        $(modalCloseBtn).on('click', function() {
            $(modal).removeClass('modal--active');
        });
    }
};
